import api from "./core";

const basePath = "api/core/GroupSessionTopic";

export default {
  get(id) {
    return api.get(`${basePath}/${id}`);
  },
  update(id, data) {
    return api.patch(`${basePath}/${id}`, data);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  },
  query(filter) {
    return api.post(`${basePath}`, filter);
  },
  create(data) {
    return api.put(`${basePath}`, data);
  }
};
